import * as React from 'react';
import { Layout } from './components/Layout';
import { PublicationPriceContainer } from './components/PublicationPrice';
import { RecommendedPackagesContainer } from './components/RecommendedPackages';
import { RecommendedPackagesPaymentStatusContainer } from './components/RecommendedPackagesPaymentStatus';
import { useSelector } from 'react-redux';
import { AvailablePackagesContainer } from './components/Packages';
import { selectIsRecommendedPackagesAvailable } from '../../../../reducers/v2/recommendedPackages/selectors';
import { selectIsPackagesAvailable } from '../../../../reducers/v2/publicationPackages/selectors';

export const PublicationSectionContainer = () => {
  const isRecommendedPackagesAvailable = useSelector(selectIsRecommendedPackagesAvailable);
  const hasPackage = useSelector(selectIsPackagesAvailable);

  return (
    <Layout
      price={!isRecommendedPackagesAvailable && <PublicationPriceContainer />}
      packages={hasPackage && <AvailablePackagesContainer />}
      recommendedPackages={<RecommendedPackagesContainer />}
      recommendedPackagesPaymentStatus={<RecommendedPackagesPaymentStatusContainer />}
    />
  );
};
